import { render } from "./clinics_index.vue?vue&type=template&id=304c84a0&scoped=true"
import script from "./clinics_index.vue?vue&type=script&lang=js"
export * from "./clinics_index.vue?vue&type=script&lang=js"

import "./clinics_index.vue?vue&type=style&index=0&id=304c84a0&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304c84a0"]])

export default __exports__